(function ($) {
  Drupal.behaviors.blogWrapperV1 = {
    attach: function (context, settings) {
      var $tmpl = $('.blog-wrapper.v1'),
        $sections = $tmpl.find('.sections'),
        $cal = $tmpl.find('.calendar .inner'),
        $posts = $tmpl.find('.post'),
        $lm = $tmpl.find('.load-more'),
        lmn = 4,
        isMobile = $('body').hasClass('device-mobile');

      if (isMobile) {
        $sections = $tmpl.find('.sections-selector select');
      }

      var toggleArrow = function (ele, dro) {
        var cls = ele.attr('class'),
          ud = cls.substring(cls.lastIndexOf('-') + 1),
          nc = cls.replace(ud, dro.is(':visible') ? 'down' : 'up');

        ele.attr('class', nc);
      };

      // Instantiate the mobile section selector
      if (isMobile) {
        $sections.on('change', function () {
          window.location.href = this.value;
        });
      }

      // Only do stuff to the calendar if this isn't the mobile site
      if (isMobile == false) {
      // Add even/odd classes to each item in the calendar,
      // and a 'last' class to every 5th item,
      // and toggle the 'hover' class while rolling over each item
        $cal
          .find('.item:even')
          .addClass('even')
          .end()
          .find('.item:odd')
          .addClass('odd')
          .end()
          .find('.item')
          .hover(function () {
            $(this).toggleClass('hover');
          });

        // Create the slide down/up toggle for the calendar drop-down,
        // including toggling the up/down arrow
        $cal
          .children('.drop-title')
          .on('click', function(e) {
            var $me = $(this),
              $i = $me.children('i'),
              $d = $me.siblings('.drop');

            $d.slideToggle('fast', function () {
              toggleArrow($i, $d);
            });
          })
          .on('clickoutside', function (e) {
            var $me = $(this),
              $i = $me.children('i'),
              $d = $me.siblings('.drop');

            $d.slideUp('fast', function () {
              toggleArrow($i, $d);
            });
          })
          .end()
          .children('.drop')
          .children('.item')
          .on('click', function(e) {
            window.location.href = $(this).attr('path');
          });

        // Dynamically set the width of the items in the calendar drop-down
        var $drops = $cal.children('.drop'),
          dropWidth = $drops.eq(0).outerWidth(true),
          $items = $drops.eq(0).children('.item'),
          itemWidth = $items.eq(0).outerWidth(false);

        console.log('JGA - put code here (blog_wrapper_v1.js) to set the width/height of items in the drop-down');
      }

      // Add first/last classes to blog posts
      $posts
        .first()
        .addClass('first')
        .end()
        .last()
        .addClass('last')
        .end()
        .slice(0, lmn)
        .show();

      // Remove the "Load More" button if the # of total posts is less than
      // or equal to lmn
      if ($posts.length <= lmn && $lm.length > 0) {
        $lm.remove();
      }

      // Set the "Load More" button action if it exists on the page
      if ($lm.length > 0) {
        $lm.on('click', function(e) {
        // Show the next 5 items
          $posts
            .filter(':hidden')
            .slice(0, lmn)
            .show();

          // Hide the "Load More" button if there's no more items to show
          if ($posts.filter(':hidden').length == 0) {
            $(this).hide();
          }
        });
      }
    }
  };
})(jQuery);
